/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="wrapp-price-manager-action" v-if="isManager">
    <button class="btn btn-primary btn-primary-small btn-primary-black full-width btn-primary-with-icon btn-rounded justify-content-between" :class="{ 'is-active': isActive }" @click.prevent="managePrices">
      <span class="text">{{ $t('price-adj.cta') }}</span>
      <svg class="o-icon fill-white"><use xlink:href="#edit"></use></svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'PriceManagerButton',
  computed: {
    isManager () {
      return this.$store.getters['userAdmin/isManager']
    },
    isActive () {
      // is active
      // if current step is payment-methods-section -> CheckoutOnePage.vue:127
      // or if cart has price_adj
      const PaymentStep = 'payment-methods-section'
      let hasPricesAdjustments = this.$store.getters['cart/hasPricesAdjustments']
      let currentStep = this.$store.getters['checkout/getStepPosition'].value
      return currentStep === PaymentStep || hasPricesAdjustments
    }
  },
  methods: {
    managePrices () {
      const componentToLoad = import('theme/components/Checkout/PriceAdjustements/PriceManager.vue')
      this.$store.dispatch('ui/loadBottomActiveComponent', { component: componentToLoad })
    }
  }
}
</script>
